import { useEffect, useState } from 'react'

import {
  formatCogoEnrichLabel,
  getCogoEnrichStatus,
  subscribeCogoEnrichStatus,
  type CogoEnrichStatus,
} from './cogoEnrichWorker'

/** Live background-enrich status from the global worker. */
export function useCogoEnrichStatus() {
  const [status, setStatus] = useState<CogoEnrichStatus>(getCogoEnrichStatus)

  useEffect(() => subscribeCogoEnrichStatus(setStatus), [])

  return {
    status,
    label: formatCogoEnrichLabel(status),
    active: status.enabled && status.phase === 'enriching',
  }
}
